import { createReducer, on } from '@ngrx/store';
import { ReportSkinHealthGuidelineAnalysisActions } from './analysis.actions';
import { ReportSkinHealthGuidelineAnalysisState } from './analysis.interface';
import {
  initialReportSkinHealthGuidelineAnalysisState,
  reportSkinHealthGuidelineAnalysisState
} from './analysis.state';

export const reportSkinHealthGuidelineAnalysisReducer = createReducer(
  reportSkinHealthGuidelineAnalysisState,
  on(
    ReportSkinHealthGuidelineAnalysisActions.reset,
    (): ReportSkinHealthGuidelineAnalysisState =>
      initialReportSkinHealthGuidelineAnalysisState()
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.setLoading,
    (state, { loading }) => ({
      ...state,
      loading
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.setLoadingSubmission,
    (state, { loadingSubmission }) => ({
      ...state,
      loadingSubmission
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.setIsPreviewAnalysis,
    (state, { isAnalysisPreview }) => ({
      ...state,
      isAnalysisPreview
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.faceAnalysisSubscriptionResponse,
    (state, { data }) => ({
      ...state,
      faceAnalysisResponse: data
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.submitProcessFaceAnalysisStatus,
    (state, { status }) => ({
      ...state,
      submitProcessFaceAnalysisStatus: status
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.findLatestByUserResponse,
    (state, { data }) => ({
      ...state,
      findLatestByUserResponse: data
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.setIsContinueLastProcess,
    (state, { isContinueLastProcess }) => ({
      ...state,
      isContinueLastProcess
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.setIsLastProcessHasFinished,
    (state, { isLastProcessHasFinished }) => ({
      ...state,
      isLastProcessHasFinished
    })
  ),
  on(
    ReportSkinHealthGuidelineAnalysisActions.submitResultFaceAnalysisStatus,
    (state, { status }) => ({
      ...state,
      submitResultFaceAnalysisStatus: status
    })
  )
);
